import CardBox from 'components/custom_v2/CardBox';
import React, { useEffect, useState } from 'react';
import IntlMessages from 'utils/IntlMessages';
import FeatherIcon from 'components/custom/FeatherIcon';
import { useFetch } from 'hooks';
import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';
import KotlerTableTitle from 'components/custom/KotlerTableTitle';
import {
  getFeatures,
  postFeature,
} from 'modules/changelog/services/ChangelogService';
import { FeatureRowForm } from './FeatureRowForm';
import { FeatureRow } from './FeatureRow';

export const FeatureTable = ( { changelogId } ) => {
  const [isCreating, setIsCreating] = useState( false );

  const { data, fetchData } = useFetch( () => getFeatures( changelogId ), { initialData: [] } );

  const { fetchData: onSaveNew } = useFetch(
    async ( values ) => {
      const dataToSend = values;
      return postFeature( changelogId, dataToSend );
    },
    {
      onSuccess: () => {
        setIsCreating( false );
        fetchData();
      },
    },
  );
  useEffect( () => {
    fetchData();
  }, []); //eslint-disable-line

  return (
    <div className="app-wrapper">
      {/* <FilterForm
      newBtn={<NewEntityBtn label="newUniversity" linkTo="/universities/new" />}
      onSubmit={this.submitForm}
      onClear={() => {
        this.search = {};
        this.getData( this.params );
      }}
    >
      <div className="col-lg-3">
        <TextField field="name" label="name" />
      </div>
    </FilterForm> */}
      <CardBox styleName="px-2 mt-4 pb-0 overflow-auto">
        <div className="jr-link" />
        <div className="position-absolute " style={{ top: 0, right: 0 }}>
          {isCreating ? (
            <IconButton
              onClick={() => {
                setIsCreating( false );
              }}
              className="square-icon-button-danger"
            >
              <FeatherIcon icon="x" color="error.main" size="18px" />
            </IconButton>
          ) : (
            <IconButton
              className="square-icon-button-primary2 "
              onClick={() => setIsCreating( true )}
            >
              <FeatherIcon icon="plus" color="primary2.light" size="18px" />
            </IconButton>
          )}
        </div>
        <KotlerTableTitle icon="gitCommit" title="features" />
        <div
          className="kotler-table-container overflow-visible  d-flex flex-column"
          style={{ minHeight: '200px' }}
        >
          <Table className="kotler-table mb-0">
            <TableHead>
              <TableRow>
                <TableCell>
                  <IntlMessages id="type" />
                </TableCell>
                <TableCell>
                  <IntlMessages id="enDescription" />
                </TableCell>
                <TableCell>
                  <IntlMessages id="esDescription" />
                </TableCell>
                <TableCell colSpan={2} />
              </TableRow>
            </TableHead>
            <TableBody>
              {isCreating && (
                <FeatureRowForm
                  onSubmit={onSaveNew}
                  onCancel={() => setIsCreating( false )}
                />
              )}
              {data.map( feature => (
                <FeatureRow
                  changelogId={changelogId}
                  feature={feature}
                  key={feature.id}
                  onFetchData={fetchData}
                />
              ) )}
            </TableBody>
          </Table>
        </div>
      </CardBox>
    </div>
  );
};

export default FeatureTable;
